<template>
  <footer
    class="bg-gray-600 text-white text-xs leading-normal"
    :style="{ backgroundColor: '#4f5151' }"
  >
    <div
      class="container px-7 xl:px-60 2xl:px-80 py-10 mx-auto text-center"
    >
      <div
        v-if="branded"
        class="mb-10"
      >
        ©2023 The Group, Inc. All rights reserved
      </div>
      <div>
        <a
          href="https://tribus.com"
          rel="noopener"
          target="_blank"
        >
          <img
            alt="Powered by TRIBUS"
            class="inline-block"
            height="32"
            src="../assets/tribus-footer-logo.png"
            srcset="../assets/tribus-footer-logo@2x.png 2x"
            width="114"
          >
        </a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'PropertyFooter',

  props: {
    branded: {
      required: true,
      type: Boolean,
    },
    property: {
      required: true,
      type: Object,
    },
  },
};
</script>
